export default [
  {
    serviceNumber: '19100540000000000001',
    serviceName:
      '19100540000000000001. Предоставление социального обслуживания в форме на дому включая оказание социально-бытовых услуг, социально-медицинских услуг, социально-психологических услуг, социально-педагогических услуг, социально-трудовых услуг, социально-правовых услуг, услуг в целях повышения коммуникативного потенциала получателей социальных услуг, имеющих ограничения жизнедеятельности, в том числе детей-инвалидов, срочных социальных услуг',
    rows: [
      {
        serviceContent1: '',
        serviceContent2: '',
        serviceContent3: '',
        service1Form: 'очно',
        service2Form: 'Бесплатно, Платно',
        volumeIndicatorName: 'Численность граждан, получивших социальные услуги',
        volumeUnit: 'Человек',
        volumeIndicatorPlannedValue: '36 560,91',
        volumeIndicatorActualValue: '18 440,65',
      },
    ],
  },
  {
    serviceNumber: '19100550000000000001',
    serviceName:
      '19100550000000000001. Предоставление социального обслуживания в полустационарной форме включая оказание социально-бытовых услуг, социально-медицинских услуг, социально-психологических услуг, социально-педагогических услуг, социально-трудовых услуг, социально-правовых услуг, услуг в целях повышения коммуникативного потенциала получателей социальных услуг, имеющих ограничения жизнедеятельности, в том числе детей-инвалидов, срочных социальных услуг',
    rows: [
      {
        serviceContent1: '',
        serviceContent2: '',
        serviceContent3: '',
        service1Form: 'очно',
        service2Form: 'Бесплатно, Платно',
        volumeIndicatorName: 'Численность граждан, получивших социальные услуги',
        volumeUnit: 'Человек',
        volumeIndicatorPlannedValue: '314 046,00',
        volumeIndicatorActualValue: '155 415,00',
      },
    ],
  },
  {
    serviceNumber: '19100560000000000001',
    serviceName:
      '19100560000000000001. Предоставление социального обслуживания в стационарной форме включая оказание социально-бытовых услуг, социально-медицинских услуг, социально-психологических услуг, социально-педагогических услуг, социально-трудовых услуг, социально-правовых услуг, услуг в целях повышения коммуникативного потенциала получателей социальных услуг, имеющих ограничения жизнедеятельности, в том числе детей-инвалидов, срочных социальных услуг',
    rows: [
      {
        serviceContent1: '',
        serviceContent2: '',
        serviceContent3: '',
        service1Form: 'очно',
        service2Form: 'Бесплатно, Платно',
        volumeIndicatorName: 'Численность граждан, получивших социальные услуги',
        volumeUnit: 'Человек',
        volumeIndicatorPlannedValue: '9 083,90',
        volumeIndicatorActualValue: '4 390,07',
      },
    ],
  },
  {
    serviceNumber: '804200О.99.0.ББ63АБ92000',
    serviceName:
      '804200О.99.0.ББ63АБ92000. Реализация основных профессиональных образовательных программ профессионального обучения - программам переподготовки рабочих и служащих',
    rows: [
      {
        serviceContent1: 'не указано',
        serviceContent2: 'не указано',
        serviceContent3: 'не указано',
        service1Form: 'Очная',
        service2Form: '',
        volumeIndicatorName: 'Количество человеко-часов',
        volumeUnit: 'Человеко-час',
        volumeIndicatorPlannedValue: '21 879,00',
        volumeIndicatorActualValue: '13 014,00',
      },
    ],
  },
  {
    serviceNumber: '804200О.99.0.ББ64АБ92000',
    serviceName:
      '804200О.99.0.ББ64АБ92000. Реализация основных профессиональных образовательных программ профессионального обучения - программ повышения квалификации рабочих и служащих',
    rows: [
      {
        serviceContent1: 'не указано',
        serviceContent2: 'не указано',
        serviceContent3: 'не указано',
        service1Form: 'Очная',
        service2Form: '',
        volumeIndicatorName: 'Количество человеко-часов',
        volumeUnit: 'Человеко-час',
        volumeIndicatorPlannedValue: '9 009,00',
        volumeIndicatorActualValue: '4 593,00',
      },
    ],
  },
  {
    serviceNumber: '804200О.99.0.ББ65АВ01000',
    serviceName:
      '804200О.99.0.ББ65АВ01000. Реализация основных профессиональных образовательных программ профессионального обучения - программ профессиональной подготовки по профессиям рабочих, должностям служащих',
    rows: [
      {
        serviceContent1: 'не указано',
        serviceContent2: 'не указано',
        serviceContent3: 'не указано',
        service1Form: 'Очная',
        service2Form: '',
        volumeIndicatorName: 'Количество человеко-часов',
        volumeUnit: 'Человеко-час',
        volumeIndicatorPlannedValue: '72 072,00',
        volumeIndicatorActualValue: '44 224,00',
      },
    ],
  },
  {
    serviceNumber: '852101О.99.0.ББ29БП24000',
    serviceName:
      '852101О.99.0.ББ29БП24000. Реализация образовательных программ среднего профессионального образования - программ подготовки квалифицированных рабочих, служащих',
    rows: [
      {
        serviceContent1: 'Физические лица с ОВЗ и инвалиды',
        serviceContent2: '09.01.03 Мастер по обработке цифровой информации',
        serviceContent3: 'Основное общее образование',
        service1Form: 'Очная',
        service2Form: '',
        volumeIndicatorName: 'Численность обучающихся',
        volumeUnit: 'Человек',
        volumeIndicatorPlannedValue: '3,20',
        volumeIndicatorActualValue: '1,89',
      },
    ],
  },
  {
    serviceNumber: '852101О.99.0.ББ29МЖ40000',
    serviceName:
      '852101О.99.0.ББ29МЖ40000. Реализация образовательных программ среднего профессионального образования - программ подготовки квалифицированных рабочих, служащих',
    rows: [
      {
        serviceContent1: 'Физические лица с ОВЗ и инвалиды',
        serviceContent2: '29.01.02 Обувщик (широкого профиля)',
        serviceContent3: 'Основное общее образование',
        service1Form: 'Очная',
        service2Form: '',
        volumeIndicatorName: 'Численность обучающихся',
        volumeUnit: 'Человек',
        volumeIndicatorPlannedValue: '1,60',
        volumeIndicatorActualValue: '0,94',
      },
    ],
  },
  {
    serviceNumber: '852101О.99.0.ББ29РР36000',
    serviceName:
      '852101О.99.0.ББ29РР36000. Реализация образовательных программ среднего профессионального образования - программ подготовки квалифицированных рабочих, служащих',
    rows: [
      {
        serviceContent1: 'Физические лица с ОВЗ и инвалиды',
        serviceContent2: '54.01.03 Фотограф',
        serviceContent3: 'Основное общее образование',
        service1Form: 'Очная',
        service2Form: '',
        volumeIndicatorName: 'Численность обучающихся',
        volumeUnit: 'Человек',
        volumeIndicatorPlannedValue: '2,40',
        volumeIndicatorActualValue: '1,41',
      },
    ],
  },
  {
    serviceNumber: '852101О.99.0.ББ29РР52000',
    serviceName:
      '852101О.99.0.ББ29РР52000. Реализация образовательных программ среднего профессионального образования - программ подготовки квалифицированных рабочих, служащих',
    rows: [
      {
        serviceContent1: 'Физические лица с ОВЗ и инвалиды',
        serviceContent2: '54.01.03 Фотограф',
        serviceContent3: 'Среднее общее образование',
        service1Form: 'Очная',
        service2Form: '',
        volumeIndicatorName: 'Численность обучающихся',
        volumeUnit: 'Человек',
        volumeIndicatorPlannedValue: '0,80',
        volumeIndicatorActualValue: '0,47',
      },
    ],
  },
];
